import HowToRegIcon from "@mui/icons-material/HowToReg";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import ListApprovedCandidacies from "./List";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <HowToRegIcon />,
  name: `${DoctoralServicePath}approved-candidacies`,
  title: "Приети докторанти",
  list: <ListApprovedCandidacies />,
  permission: permissions.canPreviewApprovedDoctoralCandidacies,
};
